<template>
  <intern-file-upload
    :year-select="false"
    :one-file-at-time="false"
    :download-file-list="currentFileNameListGetter"
    @upload="upload"
    @download="download"
    @deleteFile="deleteFile"
  />
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import InternFileUpload from '~components/common/forms/InternFileUpload'
export default {
  name: 'TeachersStudentDetailFileUpload',
  components: {
    InternFileUpload,
  },
  computed: {
    ...mapGetters('pages/teachers', [
      'currentFileNameListGetter',
    ]),
  },
  async created () {
    this.togglePageLoader(true);
    await this.loadFileNameList();
    this.togglePageLoader(false);
  },
  data () {
    return {
      formType: 'other_file',
    };
  },
  methods: {
    ...mapActions('layouts', [
      'togglePageLoader'
    ]),
    ...mapActions('pages/teachers', [
      'getFileNameList',
      'uploadInternFormFile',
      'downloadInternFormFile',
      'deleteInternFile',
    ]),
    async loadFileNameList() {
      await this.getFileNameList({
        type: this.formType,
        params: {
          enterprise_id: this.$route.params.eid,
          student_id: this.$route.params.sid,
          year: this.$route.params.year,
        },
      });
    },
    async upload (uploadFileList, year) {
      this.togglePageLoader(true);
      let form = new FormData();
      uploadFileList.forEach(file => form.append('files[]', file));
      form.append('enterprise_id', this.$route.params.eid);
      form.append('student_id', this.$route.params.sid);
      form.append('year', this.$route.params.year);
      await this.uploadInternFormFile({
        type: this.formType,
        params: form,
      });
      await this.loadFileNameList();
      this.togglePageLoader(false);
    },
    async download (form_id) {
      await this.downloadInternFormFile({
        type: this.formType,
        form_id,
      });
    },
    async deleteFile (form_id) {
      this.togglePageLoader(true);
      await this.deleteInternFile({
        type: this.formType,
        form_id,
      });
      await this.loadFileNameList();
      this.togglePageLoader(false);
    },
  }
}
</script>
